import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {CreateCancelButtons, NumericFormatCustom, SelectTimeOnly, SwitchMain, TextToolTip} from "components";
import {httpRequestsOnSuccessActions, payerActions} from 'store'
import {Svg} from "assets";
import {FindLoad, FindSuccess, toAmPm} from "utils";

const ACTION_TYPE_EDIT_PAYER_TIME_RULES = 'EDIT_PAYER_TIME_RULES'
const ACTION_TYPE_ENABLE = 'PAYER_ENABLE_TIME'

export const ApptTimeRules = ({currentId}) => {
    const [isEdit, setIsEdit] = useState(false);
    const {payerSingle} = useSelector((state) => ({
        payerSingle: state.payers.payerSingle,
    }));
    const dispatch = useDispatch();
    const {control: controlEnabled, setValue} = useForm();
    const {handleSubmit, control, reset} = useForm();
    const enableLoading = FindLoad(ACTION_TYPE_ENABLE)
    const timeRulesLoading = FindLoad(ACTION_TYPE_EDIT_PAYER_TIME_RULES)
    const timeRulesSuccess = FindSuccess(ACTION_TYPE_EDIT_PAYER_TIME_RULES)
    const {timeRules} = payerSingle;

    useEffect(() => {
        if (timeRulesSuccess?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_EDIT_PAYER_TIME_RULES));
            setIsEdit(false);
        }

    }, [timeRulesSuccess])

    useEffect(() => {
        const params = {
            ...timeRules,
        }
        delete params?.enabled;

        reset(params);
        setValue('enabled', timeRules?.enabled);
    }, [timeRules])


    const toggleEnableSwitch = (_, checked) => {
        dispatch(payerActions.enablePayerApptTime(payerSingle?.id, {enabled: checked}));
    }

    const toggleEdit = () => {
        setIsEdit(prev => !prev);
    }

    const onSubmit = (data) => {
        const body = {...data};
        delete body?._id;
        dispatch(payerActions.editPayerTimeRules(currentId, body));
    }

    return (
        <div className='payer-appt-time-rules-wrapper'>
            <div className='space-between' style={{marginBottom: 12}}>
                <SwitchMain
                    onChange={toggleEnableSwitch}
                    label='Enable Appt Time Rules'
                    name='enabled'
                    control={controlEnabled}
                    loading={!!enableLoading}
                />

                {!isEdit &&
                    <button
                        className='reset-btn flex'
                        type={'button'}
                        onClick={toggleEdit}
                        style={{width: 'fit-content'}}
                    >
                        <Svg.EditInfoSvg
                            filter='brightness(0) saturate(100%) invert(13%) sepia(51%) saturate(843%) hue-rotate(178deg) brightness(101%) contrast(94%)'
                        />
                    </button>
                }
            </div>

            <form
                className='payer-appt-time-rules-form'
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="payer-appt-time-rules-block-scroll">
                    <div className='payer-appt-time-rules-block'>
                        <div style={{marginBottom: 16}}>
                            <h3 className='payer-appt-time-rules-title'>
                                Appointment pickup settings
                            </h3>

                            <div className='align-center' style={{gap: 16}}>
                                <div className="payer-appt-time-rules-settings">
                                    <div className='align-center' style={{gap: 8, marginBottom: 6}}>
                                        <h4 className='payer-appt-time-input-title'>
                                            P/U Time
                                        </h4>

                                        <TextToolTip
                                            text={<Svg.InfoMainSvg/>}
                                            content='The pickup should occur before the appt time'
                                            showTooltip
                                            wrapperStyles={{width: 'fit-content'}}
                                            textStyles={{width: 'fit-content', display: 'flex'}}
                                        />
                                    </div>

                                    {!isEdit ?
                                        <div className='payer-appt-time-input-default'>
                                            <TextToolTip
                                                text={timeRules?.puMin}
                                                content={timeRules?.puMin}
                                                classNameText='payer-appt-time-input-default-text'
                                            />

                                            <p className='payer-appt-time-input-default-helper'>
                                                minutes
                                            </p>
                                        </div>
                                        :
                                        <NumericFormatCustom
                                            classNameWrapper='payer-appt-time-input-numeric'
                                            name={`puMin`}
                                            placeholder="Minutes"
                                            fixedDecimalScale={true}
                                            decimalScale={0}
                                            control={control}
                                            showError={false}
                                            suffix={' minutes'}
                                        />
                                    }
                                </div>

                                <div className="payer-appt-time-rules-settings">
                                    <div className='align-center' style={{gap: 8, marginBottom: 6}}>
                                        <h4 className='payer-appt-time-input-title'>
                                            Escort P/U Time
                                        </h4>

                                        <TextToolTip
                                            text={<Svg.InfoMainSvg/>}
                                            content='The escort should be picked up before the appointment P/U Time'
                                            showTooltip
                                            wrapperStyles={{width: 'fit-content'}}
                                            textStyles={{width: 'fit-content', display: 'flex'}}
                                        />
                                    </div>

                                    {!isEdit ?
                                        <div className='payer-appt-time-input-default'>
                                            <TextToolTip
                                                text={timeRules?.escortPuMin}
                                                content={timeRules?.escortPuMin}
                                                classNameText='payer-appt-time-input-default-text'
                                            />

                                            <p className='payer-appt-time-input-default-helper'>
                                                minutes
                                            </p>
                                        </div>
                                        :
                                        <NumericFormatCustom
                                            classNameWrapper='payer-appt-time-input-numeric'
                                            name={`escortPuMin`}
                                            placeholder="Minutes"
                                            fixedDecimalScale={true}
                                            decimalScale={0}
                                            control={control}
                                            showError={false}
                                            suffix={' minutes'}
                                        />
                                    }
                                </div>
                            </div>
                        </div>

                        <div>
                            <h3 className='payer-appt-time-rules-title'>
                                Return pickup settings
                            </h3>

                            <div className='align-center' style={{gap: 16}}>
                                <div className="payer-appt-time-rules-settings">
                                    <div className='align-center' style={{gap: 8, marginBottom: 6}}>
                                        <h4 className='payer-appt-time-input-title'>
                                            P/U Time
                                        </h4>
                                    </div>
                                    {!isEdit ?
                                        <div className='payer-appt-time-input-default'>
                                            <TextToolTip
                                                text={toAmPm(timeRules?.returnTime)}
                                                content={toAmPm(timeRules?.returnTime)}
                                                classNameText='payer-appt-time-input-default-text'
                                            />

                                            <p className='payer-appt-time-input-default-helper'>
                                                <Svg.AccessTimeSvg/>
                                            </p>
                                        </div>
                                        :
                                        <SelectTimeOnly
                                            name={`returnTime`}
                                            control={control}
                                            placeholder="00:00 AM"
                                        />
                                    }
                                </div>

                                <div className="payer-appt-time-rules-settings">
                                    <div className='align-center' style={{gap: 8, marginBottom: 6}}>
                                        <h4 className='payer-appt-time-input-title'>
                                            Escort Return P/U Time
                                        </h4>
                                    </div>

                                    {!isEdit ?
                                        <div className='payer-appt-time-input-default'>
                                            <TextToolTip
                                                text={toAmPm(timeRules?.escortReturnTime)}
                                                content={toAmPm(timeRules?.escortReturnTime)}
                                                classNameText='payer-appt-time-input-default-text'
                                            />

                                            <p className='payer-appt-time-input-default-helper'>
                                                <Svg.AccessTimeSvg/>
                                            </p>
                                        </div>
                                        :
                                        <SelectTimeOnly
                                            name={`escortReturnTime`}
                                            control={control}
                                            placeholder="00:00 AM"
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isEdit &&
                    <CreateCancelButtons
                        createText={"Save Changes"}
                        loading={!!timeRulesLoading}
                        createBtnStyles={{width: 158}}
                        wrapperStyles={{padding: 0, border: 'none'}}
                        onCancel={toggleEdit}
                    />
                }
            </form>
        </div>
    );
};

